import { FC } from 'react';
import { DotProps } from 'recharts';

export const SquareDot: FC<DotProps & { color: string }> = ({
  className,
  cx,
  cy,
  color,
}) => (
  <svg x={cx! - 5} y={cy! - 5} width={20} height={20} fill={color}>
    <rect className={className} width={10} height={10} fill={color} />
  </svg>
);
